import React from 'react';
import { Switch as HeadlessSwitch } from '@headlessui/react';
import classnames from 'classnames';

const Switch = ({ checked, onChange, srTitle, name, ...rest }: any) => (
  <HeadlessSwitch
    checked={checked}
    onChange={onChange}
    className={classnames(
      checked ? 'bg-primary-600' : 'bg-gray-200',
      'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500'
    )}
    name={name}
    value={checked.toString()}
    data-testid={name}
    {...rest}
  >
    <span className="sr-only">{srTitle}</span>
    <span
      aria-hidden="true"
      className={classnames(
        checked ? 'translate-x-5' : 'translate-x-0',
        'inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
      )}
    />
  </HeadlessSwitch>
);

export default Switch;
